export default __webpack_public_path__ + "static/media/Penguins.6b3a8c44.png";